import { BaseComponent } from '../../base-component';

type EventData = {
    name: string;
};

export class SustainabilityShortInfoSheetComponent extends BaseComponent {
    public rootSelector = '.js_pdp_sustainability-short-info-sheet';

    public async init(): Promise<void> {
        this.registerOpenSustainabilitySheetEvent();
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
    }

    protected openContentSheet(data: EventData): void {
        const categoryElement = this.getRootElement().querySelector(
            `.js_pdp_sustainability-short-info-sheet__category-${data.name}`
        ) as HTMLElement;
        const sheet = new o_global.pali.sheetBuilder({
            title: 'Was bedeutet dieses Zeichen?',
            content: categoryElement.innerHTML,
        });
        sheet.open();
    }

    private registerOpenSustainabilitySheetEvent(): void {
        o_global.eventQBus.on('ft5.pdp-sustainability-short-info-sheet.open', async (data: EventData) => {
            this.openContentSheet(data);
        });
    }
}
